import { CatalogItemDetailsChipsBlock } from './CatalogItemDetailsChipsBlock'
import { CatalogItemDetailsKeyValueBlock } from './CatalogItemDetailsKeyValueBlock'
import { CatalogItemDetailsListBlock } from './CatalogItemDetailsListBlock'
import { CatalogItemDetailsTableBlock } from './CatalogItemDetailsTableBlock'
import { CatalogItemDetailsTextBlock } from './CatalogItemDetailsTextBlock'
import { type ConversationDetailBlock } from '../../value-objects/ConversationTurnItem'
import { ConversationDetailBlockTypes } from '../../value-objects/enums'

export interface ICatalogItemDetailsBlockProps {
  block: ConversationDetailBlock
  isCallout: boolean
  onChipSelect: (message: string) => void
}

export const CatalogItemDetailsBlock = ({
  block,
  isCallout,
  onChipSelect,
}: ICatalogItemDetailsBlockProps) => {
  switch (block.type) {
    case ConversationDetailBlockTypes.TEXT:
      return <CatalogItemDetailsTextBlock block={block} isCallout={isCallout} />
    case ConversationDetailBlockTypes.KEY_VALUE:
      return <CatalogItemDetailsKeyValueBlock block={block} />
    case ConversationDetailBlockTypes.TABLE:
      return <CatalogItemDetailsTableBlock block={block} />
    case ConversationDetailBlockTypes.LIST:
      return <CatalogItemDetailsListBlock block={block} />
    case ConversationDetailBlockTypes.CHIPS:
      return (
        <CatalogItemDetailsChipsBlock
          block={block}
          onChipSelect={onChipSelect}
        />
      )
    default:
      return null
  }
}
